import {provideTransloco, TranslocoDirective, TranslocoModule, TranslocoPipe} from '@jsverse/transloco';
import { isDevMode, NgModule } from '@angular/core';
import {TranslocoHttpLoader} from './transloco-http.loader';


@NgModule({
  imports: [TranslocoDirective, TranslocoPipe],
  exports: [TranslocoModule, TranslocoDirective, TranslocoPipe],
  providers: [
    provideTransloco({
      config: {
        availableLangs: ['en'],
        defaultLang: 'en',
        prodMode: !isDevMode()
      },
      loader: TranslocoHttpLoader,
    }),
  ],
})
export class TranslocoRootModule {}
